<template>
  <div class="big-box">
    <!-- <navigation :crumbs="crumbs" @jumpColumn="jumpColumn" /> -->
    <list v-if="type == 0 " :notice="noticeObj" />
    <navigationList v-if="type == 1 " :notice="noticeObj" @handlerCrumbs="handlerCrumbs" />
  </div>
</template>

<script>
import list from '@/components/list';
// import navigation from '@/components/navigation';
import navigationList from '@/components/navigationList';
import { mapState } from 'vuex';
import { getNavigation } from '@/api/common';

export default {
  name: 'Index',
  components: {
    list,
    // navigation,
    navigationList
  },
  data() {
    return {
      newsTitle: '辟谣要闻',
      noticeTitle: '公告栏',
      noticeObj: { },
      type: -1, // 0 没左侧栏目  1有左侧栏目
      crumbs: []
    };
  },

  computed: {
    ...mapState(['platFromArray', 'columnTree'])

  },
  watch: {
    '$route': {
      immediate: true,
      handler(to, from) {
        this.refresh(this.$route.query.name)
      }
    }
  },
  created: function() {
    // this.columnList();
  },
  methods: {
    refresh(name) {
      this.type = -1
      this.columnList();
    },
    columnList() {
      const data = this.$route.query.name;
      getNavigation(data).then(res => {
        if (data === '最新发布') {
          this.noticeObj.name = data;
          this.noticeObj.queryText = '';
          this.noticeObj.showType = 0
          // 一级栏目写死
          this.type = 0
          return
        }
        const curColumn = JSON.parse(res.data.value).filter(v => v.text === data)[0]
        if (curColumn.text === '工作动态' || curColumn.text === '涨知识') {
          this.noticeObj.showType = 0
        } else {
          this.noticeObj.showType = 1
        }
        this.noticeObj.name = curColumn.text;
        // 配置驱动：若后台为该栏目配置了 queryText，则列表/标题查询时作为 customLabel 使用（多文案逗号并集）
        this.noticeObj.queryText = (curColumn && curColumn.queryText) || '';
        console.log('%c 🥚 this.noticeObj: ', 'font-size:20px;background-color: #33A5FF;color:#fff;', this.noticeObj);
        // 一级栏目写死
        this.type = 0
      })
    },
    // 兼容三级
    getCrumbs(columnName, columnObj, crtColumn) {
      const topColumnName = columnObj.filter(v => v.text === columnName);
      // 顶级
      if (topColumnName.length) {
        this.crumbs = [columnName];
        return;
      }
    },
    getCurrentColumn(columnName, columnList) {
      let crtColumn = {};
      for (let index = 0; index < columnList.length; index++) {
        const column = columnList[index];
        if (column.columnList) {
          crtColumn = this.getCurrentColumn(columnName, column.columnList)
        } else if (columnName === column.name) {
          return column;
        }
      }
      return crtColumn;
    },
    handlerCrumbs({ columnName, column }) {
      this.getCrumbs(columnName, this.noticeObj, column);
    },
    jumpColumn(colubName) {
      this.$router.push({
        path: '/subPage',
        query: {
          name: colubName
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.big-box {
  width: 100%;
  min-height: 850px;
  .main {
  }
}
</style>
